import comp from "./ResourceImagePlaceHolder";
export default comp;
